import { m } from "framer-motion";
import { buildHeaders } from "../../Auth/AuthHooks/authRouting";
import { REST_API_URL } from "../config";
import { chatEndpoints } from "./chatEndpoints";

export const getHalperChatUnreadCount = async () => {
  const HALPER_CHAT_UNREAD_COUNT_URL = `${REST_API_URL}${chatEndpoints.getHalperChatUnreadCount}`;
  try {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    const headers = buildHeaders(token);

    const res = await fetch(HALPER_CHAT_UNREAD_COUNT_URL, {
      headers,
    });

    const data = await res.json();
    return data;
  } catch (e: any) {
    console.log("Failed to load halper chat unread count", e);
    return e.message || "Failed to load halper chat unread count";
  }
};

export const postHalperMarkAsRead = async () => {
  const HALPER_MARK_AS_READ_URL = `${REST_API_URL}${chatEndpoints.postHalperMarkAsRead}`;
  try {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    const headers = buildHeaders(token);

    const res = await fetch(HALPER_MARK_AS_READ_URL, {
      method: "POST",
      headers,
    });

    const data = await res.json();
    return data;
  } catch (e: any) {
    console.log("Failed to mark halper chat as read", e);
    return e.message || "Failed to mark halper chat as read";
  }
};
